module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctc2a",
    attrs: {
      "id": "d7e28"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#ch2",
      "id": "d14e258"
    }
  }, [_c('b', [_c('big', [_vm._v("1")])], 1), _vm._v(" Tex-Mex Basics")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c9_r1#ch3",
      "id": "d14e294"
    }
  }, [_c('b', [_c('big', [_vm._v("2")])], 1), _vm._v(" Appetizers")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c10_r1#ch4",
      "id": "d14e299",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("3")])], 1), _vm._v(" Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c11_r1#ch5",
      "id": "d14e304",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("4")])], 1), _vm._v(" Soups")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c12_r1#ch6",
      "id": "d14e309",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("5")])], 1), _vm._v(" Side Dishes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c13_r1#ch7",
      "id": "d14e314",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("6")])], 1), _vm._v(" Sauces")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c14_r1#ch8",
      "id": "d14e319",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("7")])], 1), _vm._v(" Bread and Tortillas")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c15_r1#ch9",
      "id": "d14e324",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("8")])], 1), _vm._v(" Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c16_r1#ch10",
      "id": "d14e329",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("9")])], 1), _vm._v(" Poultry")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c17_r1#ch11",
      "id": "d14e334",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("10")])], 1), _vm._v(" Beef")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c18_r1#ch12",
      "id": "d14e340",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("11")])], 1), _vm._v(" Pork and Sausage")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c19_r1#ch13",
      "id": "d14e345",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("12")])], 1), _vm._v(" Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c20_r1#ch14",
      "id": "d14e350",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("13")])], 1), _vm._v(" Vegetarian")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c21_r1#ch15",
      "id": "d14e355",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("14")])], 1), _vm._v(" Beverages")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc_p16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c22_r1#ch16",
      "id": "d14e360",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('big', [_vm._v("15")])], 1), _vm._v(" Desserts")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "toc_p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c7_r1#ch1",
      "id": "d14e255"
    }
  }, [_vm._v("Introduction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s1",
      "id": "d14e263"
    }
  }, [_vm._v("Origins of Tex-Mex")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s2",
      "id": "d14e266"
    }
  }, [_vm._v("A Cuisine is Born")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s3",
      "id": "d14e269"
    }
  }, [_vm._v("Tex-Mex Ingredients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s4",
      "id": "d14e272"
    }
  }, [_vm._v("Special Techniques")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s5",
      "id": "d14e275"
    }
  }, [_vm._v("Cooking Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s6",
      "id": "d14e278"
    }
  }, [_vm._v("The Name Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s7",
      "id": "d14e281"
    }
  }, [_vm._v("Food Safety")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s8",
      "id": "d14e284"
    }
  }, [_vm._v("The Essential Cheese")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s9",
      "id": "d14e288"
    }
  }, [_vm._v("All about Chiles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "toc_s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c8_r1#s10",
      "id": "d14e291"
    }
  }, [_vm._v("Let's Cook!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "toc_p17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c23_r1#ch17",
      "id": "d14e365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Tex-Mex Glossary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "toc_p18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/auth_ISBNXXXXXXXXX_epub_c24_r1#ch18",
      "id": "d14e368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Menu Suggestions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "d7e57"
    }
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "cook-book_0vii_003",
      "src": "images/cook-book_0vii_003.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "d7e58"
    }
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "cook-book_viii_004",
      "src": "images/cook-book_viii_004.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e10752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth_ISBNXXXXXXXXX_epub_c5_r1.vue
// module id = 75
// module chunks = 0